import script from "./HeroConnectWalletButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeroConnectWalletButton.vue?vue&type=script&lang=ts&setup=true"

import "./HeroConnectWalletButton.vue?vue&type=style&index=0&id=2733091f&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2733091f"]])

export default __exports__